import React from 'react'

import logo from "../assets/logo.svg"

import discord_white from "../assets/discord-white.svg"
import twitter_white from "../assets/twitter-white.svg"
import stacks_white from "../assets/stacks-white.svg"
import medium from "../assets/medium.svg"

function Footer() {
    return (
        <>
            <footer>
                <div className="container">
                    <div className="row footer-content">

                        <div className="col-md-4 col-sm-12 text-center show-img">
                            <img src={logo} alt="logo" className='img-fluid' style={{ paddingTop: "0.75rem" }} />
                        </div>

                        <div className="col-md-4 col-sm-12">
                            <p>Copyright © 2022 Megapont</p>
                        </div>

                        <div className="col-md-4 col-sm-12 text-center hide-img">
                            <img src={logo} alt="logo" className='img-fluid' style={{ paddingTop: "0.75rem" }} />
                        </div>

                        <div className="col-md-4 col-sm-12">
                            <div className="icons">
                                <a href="#" >
                                    <img src={discord_white} alt="discord" className='img-fluid' style={{ marginRight: "2.5rem" }} />
                                </a>
                                <a href="#">
                                    <img src={twitter_white} alt="twitter" className='img-fluid' style={{ marginRight: "2.5rem" }} />
                                </a>
                                <a href="#">
                                    <img src={stacks_white} alt="stacks" className='img-fluid' style={{ marginRight: "2.5rem" }} />
                                </a>
                                <a href="#">
                                    <img src={medium} alt="medium" className='img-fluid' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
